module.exports = __webpack_public_path__ + "f7eb7e2f29a4f8f75f675c4ebc0f5324.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/workshop-hat.jpg
 ** module id = 459
 ** module chunks = 0
 **/